import Request from '@/api/request';
import { IFileData } from '@/api/filestorage';

const api = new Request();

interface CheckSignResponse {
  status: 'OK' | 'ERROR';
  message: string;
  file: IFileData;
  signFile: IFileData;
}

/** валидация и сохранение файла, подписи файла */
export async function checkSign(
  file: Blob,
  fileSig: Blob
): Promise<CheckSignResponse> {
  const formData = new FormData();

  formData.append('file', file);
  formData.append('sign', fileSig);

  return api.post('lk/sign/check', formData);
}
